/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetRadialIcon16Regular = forwardRef('TargetRadialIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 9.375a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.825 8.005a4.175 4.175 0 1 1 8.35 0 4.175 4.175 0 0 1-8.35 0ZM8 5.33a2.675 2.675 0 1 0 0 5.35 2.675 2.675 0 0 0 0-5.35Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.004a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
